import type { Alert, Confirm } from 'types'
import store from './store'

export const alerts = store<Alert[]>([])

export const confirm = store<Confirm | null>(null)
